import { gql } from '@apollo/client';

export const SUBSCRIPTION_NEW_MESSAGES = gql`
  subscription chatNotificationForUser {
    chatNotificationForUser {
      key
      newNotifications
    }
  }
`;

export const SUBSCRIPTION_NEW_OFFER = gql`
  subscription newOffer {
    newOffer {
      key
      newNotifications
    }
  }
`;

export const SUBSCRIPTION_NEW_APPLICATION = gql`
  subscription newApplication {
    newApplication {
      key
      newNotifications
    }
  }
`;
